import React, { useState, useEffect } from "react";
import styles from "./styles.module.css";
import { FaRegEdit } from "react-icons/fa";
import Button from "../../../../button-v1";

const EmailPreview = ({ devices, handleEmail }) => {
  const initialEmail = () => {
    const orderLines = devices
      .map(
        (device, index) =>
          `${index + 1}: We need ${device.quantity} ${device.name} Devices`
      )
      .join("\n");
    return {
      subject: "Bulk Device Order Requirement",
      to: "khadijanawaz8302@gmail.com",
      body: `Dear fjames,
  
  I would like to place a bulk order for the following:
  ${orderLines} 
  Please arrange delivery at your earliest convenience. Kindly confirm the order and provide any further details needed to proceed.
  Thank you for your support.
  
  Best regards,
  TOCA Case Manager`,
    };
  };

  const [isEditing, setIsEditing] = useState(false);
  const [email, setEmail] = useState(initialEmail);
  const [draft, setDraft] = useState(initialEmail);

  const handleInput = (e, key) => {
    setDraft((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleEdit = () => {
    setDraft(email);
    setIsEditing(true);
  };

  const handleSave = () => {
    setEmail(draft);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setDraft(email);
    setIsEditing(false);
  };

  useEffect(() => handleEmail(email), [email]);

  const renderBody = (body) => {
    const lines = body.split(/\n+/);
    return (
      <div className={styles.readOnlyBodyContainer}>
        {lines.map((line, idx) => {
          if (/^\d+: We need/.test(line.trim())) {
            // Make order lines bold
            return (
              <p key={idx} className={styles.orderLine}>
                {line}
              </p>
            );
          }
          if (line.trim().startsWith("• ")) {
            return (
              <p key={idx} style={{ marginLeft: 20, fontWeight: 600 }}>
                <span style={{ fontSize: 18, marginRight: 8 }}>•</span>
                {line.replace(/^• /, "")}
              </p>
            );
          }
          // Normal lines
          return <p key={idx}>{line}</p>;
        })}
      </div>
    );
  };

  return (
    <>
      {isEditing ? (
        <section className={styles.container}>
          <header className={styles.containerHeader}>
            <p>Email</p>
            {!isEditing && (
              <FaRegEdit
                size={20}
                onClick={handleEdit}
                style={{ cursor: "pointer" }}
              />
            )}
          </header>
          <main className={styles.contentContainer}>
            {isEditing ? (
              <>
                <section className={styles.inputField}>
                  <h5>Subject</h5>
                  <input
                    type="text"
                    value={draft.subject}
                    onChange={(e) => handleInput(e, "subject")}
                    className={styles.editableText}
                  />
                </section>
                <section className={styles.inputField}>
                  <h5>To</h5>
                  <input
                    type="text"
                    value={draft.to}
                    onChange={(e) => handleInput(e, "to")}
                    className={styles.editableText}
                  />
                </section>
                <section>
                  <div className={styles.bodyEditContainer}>
                    <textarea
                      value={draft.body}
                      onChange={(e) =>
                        setDraft((d) => ({ ...d, body: e.target.value }))
                      }
                      className={styles.editableText}
                      style={{
                        width: "100%",
                        minHeight: 200,
                        resize: "vertical",
                        fontSize: 14,
                        fontFamily: "inherit",
                        fontWeight: 400,
                      }}
                    />
                  </div>
                </section>
                <div className={styles.editorActions}>
                  <Button variant="ghost" onClick={handleCancel}>
                    Cancel
                  </Button>
                  <Button onClick={handleSave}>Save</Button>
                </div>
              </>
            ) : (
              <section className={styles.email_view_container}>
                <section className={styles.inputField}>
                  <h5>Subject</h5>
                  <div>{email.subject}</div>
                </section>
                <section className={styles.inputField}>
                  <h5>To</h5>
                  <div>{email.to}</div>
                </section>
                <section>{renderBody(email.body)}</section>
              </section>
            )}
          </main>
        </section>
      ) : (
        <section className={styles.view_container}>
          <header className={styles.containerHeader}>
            <p>Email</p>
            {!isEditing && (
              <FaRegEdit
                size={20}
                onClick={handleEdit}
                style={{ cursor: "pointer" }}
              />
            )}
          </header>
          <main className={styles.contentContainer}>
            <section className={styles.inputField}>
              <h5>Subject</h5>
              <div>{email.subject}</div>
            </section>
            <section className={styles.inputField}>
              <h5>To</h5>
              <div>{email.to}</div>
            </section>
            <section>{renderBody(email.body)}</section>
          </main>
        </section>
      )}
    </>
  );
};

export default EmailPreview;
